var Header = require('./header');
var Alert = require('./alert');
var Index = require('./intelligentDocumentIndex');
var Detail = require('./intelligentDocumentApplication');
module.exports = san.defineComponent({
    template: require('../views/app.html'),
    initData: function () {
        return {
            showLoading: false,
            showType: 1,
            type: '',
        };
    },
    components: {
        'alert': Alert,
        'header': Header,
        'index': Index,
        'detail': Detail
    },
    created: function () {
        localStorage.sysUserId = 'unknown00008';
        var me = this;
        setTimeout(function () {
            $.ajax({
                url: "/static/bgImage.json",
                dataType: 'json',
                success: function (resp) {
                    resp.forEach(function (item) {
                        if (item.domain == document.domain) {
                            $('.bgsy').addClass(item.img);
                            san.nextTick(function () {
                                me.data.set('type', item.type);
                            })
                        }
                    })
                },
                error: function (err) {
                    console.log(err.msg);
                }
            });
            Api("post", "/api/wechatAutor/saveAnonymousUserInfo").then(function (response) {
                if (response) {
                    localStorage.sysUserId = response.user.userId;
                }
            });
            $.ajax({
                url: "/static/domain.json",
                dataType: 'json',
                success: function (resp) {
                    resp.forEach(function (item) {
                        if (item.domain == document.domain) {
                            if(!!sessionStorage.safeInfo){
                                me.ref('index').init(item.type, item.name+'法律文书');
                            }else{
                                $.ajax({
                                    url: '/api/websafe/safeInfo?domainName='+document.domain.slice(0,20),
                                    type: 'get',
                                    dataType : 'json',
                                    contentType: 'application/json',
                                    data: null,
                                    success: function(response){
                                        sessionStorage.safeInfo = response.safeInfo;
                                        me.ref('index').init(item.type, item.name+'法律文书');
                                    },
                                    error: function(err) {

                                    }
                                });
                            }
                            window.document.title = item.name+'法律文书';
                        }
                    })
                },
                error: function (err) {
                    console.log(err.msg);
                }
            });

        }, 0);
        sessionStorage.removeItem('newProfessionSet');
    },
    messages: {
        //法律法规 - 法规详情页面
        goDetail: function (key) {
            var me = this;
            me.data.set('showType', 2);
            san.nextTick(function () {
                me.ref('detail').getWsId(key.value);
                // me.ref('detail').getPdf(key.value);
            });
        },
        show: function () {
            var me = this;
            san.nextTick(function () {
                me.data.set('showLoading', true);
            });
        },
        hide: function () {
            var me = this;
            san.nextTick(function () {
                me.data.set('showLoading', false);
            });
        },
        back: function () {
            var me = this;
            switch (this.data.get('showType')) {
                case 2:
                    me.ref('detail').reset();
                    this.data.set('showType', 1);
                    break;
                case 3:
                    this.data.set('showType', 2);
                    break;
                case 4:
                    this.data.set('showType', 3);
                    break;
            }
        },
        showAlert: function (obj) {
            var params = obj.value;
            this.ref('alert').show(params.title, params.msg);
        },
        goTop: function () {
            window.Tool._scroll(document.documentElement, 0);
        }
    }
});




//////////////////
// WEBPACK FOOTER
// ./src/components/app.js
// module id = 355
// module chunks = 1